import { useLoadScript } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';

const GoogleMapsContext = createContext(null);

const GoogleMapsProvider = ({ children }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  return <GoogleMapsContext.Provider value={{ isLoaded }}>{children}</GoogleMapsContext.Provider>;
};

GoogleMapsProvider.propTypes = {
  children: PropTypes.node,
};

export default GoogleMapsProvider;

export const useGoogleMaps = () => {
  return useContext(GoogleMapsContext);
};
